var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwinCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3672_7471)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.67 2L7.5 0H13.5L15.33 2H18.5C19.6 2 20.5 2.9 20.5 4V4.4H17.73L15.9 2.4H9.9L8.07 4.4H4.9C3.8 4.4 2.9 5.3 2.9 6.4V18H2.5C1.4 18 0.5 17.1 0.5 16V4C0.5 2.9 1.4 2 2.5 2H5.67ZM11.3 20.4C12.8945 20.6899 14.2555 20.6471 15.4028 20.4H11.3ZM14.6082 19.9525C14.8343 19.9838 15.0653 20 15.3 20C18.06 20 20.3 17.76 20.3 15C20.3 12.6498 18.6758 10.6766 16.4894 10.1425C18.3083 11.0554 19.7 12.9961 19.7 15C19.7 17.5253 17.1551 19.6152 14.6082 19.9525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1 18.0006C15.8673 18.0006 17.3 16.5679 17.3 14.8006C17.3 13.0333 15.8673 11.6006 14.1 11.6006C12.3327 11.6006 10.9 13.0333 10.9 14.8006C10.9 16.5679 12.3327 18.0006 14.1 18.0006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1 4.7998L9.26998 6.7998H6.09998C4.99998 6.7998 4.09998 7.6998 4.09998 8.7998V20.7998C4.09998 21.8998 4.99998 22.7998 6.09998 22.7998H22.1C23.2 22.7998 24.1 21.8998 24.1 20.7998V8.7998C24.1 7.6998 23.2 6.7998 22.1 6.7998H18.93L17.1 4.7998H11.1ZM14.1 19.7998C11.34 19.7998 9.09998 17.5598 9.09998 14.7998C9.09998 12.0398 11.34 9.7998 14.1 9.7998C16.86 9.7998 19.1 12.0398 19.1 14.7998C19.1 17.5598 16.86 19.7998 14.1 19.7998Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3672_7471"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinCamera);
export default __webpack_public_path__ + "static/media/twin_camera.0c229c48.svg";
export { ForwardRef as ReactComponent };